<div class="iot-platform-ui-variable-card" fxLayout="row nowrap" fxLayoutGap="10px" fxLayoutAlign="space-between center">
  <div fxLayout="column" fxLayoutGap="5px" fxFlex="45">
    <span class="iot-platform-ui-variable-card__source-name">{{ source() }}</span>
    <span class="iot-platform-ui-variable-card__name fw-600">{{ name() }}</span>
  </div>

  <span
    class="iot-platform-ui-variable-card__value fw-600"
    fxFlex="15"
    [matTooltip]="lastValue() ?? 'n/a'"
    matTooltipPosition="above"
    matTooltipClass="regular-tooltip"
    >{{ lastValue() ?? 'n/a' }}
  </span>

  <span class="iot-platform-ui-variable-card__unit fw-600" fxFlex="15" [matTooltip]="unit()" matTooltipPosition="above" matTooltipClass="regular-tooltip"
    >({{ unit() }})</span
  >

  <span class="iot-platform-ui-variable-card__date" fxFlex="25">{{ (lastValueTime() | dateFormat) ?? 'n/a' }}</span>
</div>
